export const RECAPTCHA_KEY = "6LfQN_MZAAAAANASA-ko2T3qkcfR26nolaCjDxnI";

/** Keep Store alive in Seconds */
export const STORE_EXPIRATION_TIME = 0; // 0 days


/** IDs of hardcoded options */
export const Options = {
	coulterWidths: "coulterWidthsOptions",
	rowWidths: "rowWidthsOptions",
	plannedPlantations: "plannedPlantationOptions",
	trackWidth: "trackWidth",
	customerAnnotation: "customerAnnotation"
}
